module.exports = __webpack_public_path__ + "img/skin_active_menu_type1.f3b3dc44.png";